import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapGroupAdminItem } from '../mappers/groupAdmins.mapper';
import type { GroupAdminItem, LC_GetGroupAdminsOut, LC_GetGroupAdminsParams } from '../types/groupAdmins.types';


export interface GroupAdminsAvailableResult {
  items: GroupAdminItem[];
  totalRecords: number;
}

export class GroupAdminsAvailableService {
  async getAvailable(
    groupId: number,
    params?: LC_GetGroupAdminsParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<GroupAdminsAvailableResult>> {
    const queryString = buildQueryString(params ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.SECURITY_GROUPING.ADMINS_AVAILABLE(groupId)}${queryString}`;

    const response = await apiClient.get<LC_GetGroupAdminsOut>(endpoint, { signal });

    if (response.success && response.data) {
      return {
        ...response,
        data: {
          items: (response.data.data ?? []).map(mapGroupAdminItem),
          totalRecords: response.data.pagination?.totalRecords ?? 0,
        },
      };
    }

    return { ...response, data: null };
  }
}

export const groupAdminsAvailableService = new GroupAdminsAvailableService();
